module.exports = __webpack_public_path__ + "static/media/toaster-success-close.489c3b4f.svg";